import React from 'react';
import ReactDOMServer from 'react-dom/server';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import HoverTooltip from 'src/components/BeaconV2Components/HoverTooltip/HoverTooltip';
import { formatIsoDateToMMDD } from 'src/components/BeaconV2Components/SplineChartV2/splineChartV2Utils';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasPriceIndexSplineChart = () => {
  return (
    <AtlasV2DorisSplineChart
      queryKey="retailPriceSplineChart"
      title="Price Index"
      showMarketShare
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.MULTIPLE}
      metricType="RetailPrice"
      splineChartProps={{
        chartOptionsOverride: {
          yAxis: [
            {
              labels: {
                formatter() {
                  return `${formatMetric(this.value, METRICTYPE.MULTIPLE, {
                    decimalPlaces: 2,
                    showFullValue: false,
                    showNegative: true
                  })}x`;
                }
              },
              title: { text: '' }
            }
          ]
        },

        renderCustomTooltip: ({ primaryPoint, comparisonPoint, percentChange, theme, metricType }) => {
          return ReactDOMServer.renderToStaticMarkup(
            <HoverTooltip
              theme={theme}
              title={`Week ${primaryPoint.meta.weekLabel}`}
              primaryColor={theme.colors.primary}
              primaryMetric={`${formatMetric(primaryPoint.value, metricType, {
                decimalPlaces: 2,
                showFullValue: false,
                showNegative: true
              })}x`}
              primaryMetricLabel={primaryPoint.meta.isoDate ? formatIsoDateToMMDD(primaryPoint.meta.isoDate) : undefined}
              change={
                percentChange !== undefined
                  ? `${formatMetric(Math.abs(percentChange), METRICTYPE.PERCENT, { decimalPlaces: 2 })}`
                  : undefined
              }
              rawChange={percentChange}
              secondaryMetric={
                comparisonPoint
                  ? `${formatMetric(comparisonPoint.value, metricType, {
                      decimalPlaces: 2,
                      showFullValue: false,
                      showNegative: true
                    })}x`
                  : undefined
              }
              secondaryMetricLabel={comparisonPoint?.meta.isoDate ? formatIsoDateToMMDD(comparisonPoint.meta.isoDate) : undefined}
              secondaryColor={theme.colors.secondary}
            />
          );
        }
      }}
      beaconChartWithLegendOverride={(props, metricByValues) => {
        const { formattedPrimaryTotal, formattedSecondaryTotal } = metricByValues;

        return {
          ...props,
          primaryLegendProps: {
            ...props.primaryLegendProps,
            metric: `${formattedPrimaryTotal}x`
          },
          comparisonLegendProps: {
            ...props.comparisonLegendProps,
            metric: `${formattedSecondaryTotal}x`
          }
        };
      }}
    />
  );
};

export default AtlasPriceIndexSplineChart;
